import { css } from "styled-components";
import ofc from "../../settings/variables";
const styles = css`
  padding: 0 ${ofc.s3}em;
  font-size: ${ofc.x0};
`;

export default styles;
